import angular from 'angular';

angular
    .module('ladProvider', [])

    .config(function() {});
